import { onMounted, onUnmounted } from 'vue';

export default function useRegisterShortcut({
  execute,
  triggerKey,
  shortcutKey,
}: {
  execute: (e: KeyboardEvent) => void;
  triggerKey: 'keydown' | 'keyup';
  shortcutKey: KeyboardEvent['key'];
}) {
  onMounted(() => {
    document.addEventListener(triggerKey, handleShortcuts);
  });

  onUnmounted(() => {
    document.removeEventListener(triggerKey, handleShortcuts);
  });

  const handleShortcuts = (e: KeyboardEvent) => {
    if (e.key === shortcutKey) {
      preventEvent(e);

      execute(e);
    }
  };

  const preventEvent = (e: KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
}
